var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"main"}},[_c('b-container',{attrs:{"fluid":"xl"}},[_c('Front'),_c('Input',{on:{"onSubmit":_vm.onSubmit}}),_c('LempelZiv',{attrs:{"input":_vm.msg}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }